module.exports = __webpack_public_path__ + "assets/open-graph-protocol.1727d968.svg";